import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-z-edit-items',
  templateUrl: './z-edit-items.component.html',
  styleUrls: ['./z-edit-items.component.scss']
})
export class ZEditItemsComponent implements OnInit {

    productId: string | null = null;
    product: any = {
    category_id: null,
  title: '',
  content: '',
  count: 1,
  reference: '',
  order: 0,
  is_active: true
  };
   public arrCoupons: any[] = [];
  public lang : any


constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProduct(this.productId);
    }

    this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});


                     this.apiService.categories().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


  

  }

// Fetch product details
loadProduct(id: string): void {
  this.apiService.getItems(id).subscribe({
    next: (res: any) => {
      const data = res.data;

      // Map backend fields to product
      this.product.category_id = data.category_id || null;
      this.product.title = data.title || '';
      this.product.content = data.content || '';
      this.product.count = data.count || 1;
      this.product.reference = data.reference || '';
      this.product.order = data.order || 0;
      this.product.is_active = data.is_active == 1;
    },
    error: (err) => {
      console.error('Failed to load product:', err);  
      this.toastr.error('Failed to load item details');
    }
  });
}



    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product

  
    updateProduct(): void {
    if (!this.productId) return;

    this.apiService.editItems(this.productId, this.product).subscribe({
      next: (res) => {
        this.toastr.success('  updated successfully');
        this.router.navigate(['/items']); // redirect after save
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.toastr.error('Failed to update  ');
      }
    });
  }


}